import { Component, OnInit } from '@angular/core';
import { RmsModule } from '@rms';
import { LedgerRoles, LedgerService } from '@services';
import { LedgerInquiryComponent } from './ledger-inquiry/ledger-inquiry.component';
import { LedgerUnresolvedComponent } from './ledger-unresolved/ledger-unresolved.component';
import { JournalReviewComponent } from './journal-review/journal-review.component';
import { RecycleBinComponent } from './recycle-bin/recycle-bin.component';
import { AccountingPeriodsComponent } from './accounting-periods/accounting-periods.component';

@Component({
  selector: 'app-ledger',
  imports: [RmsModule, LedgerInquiryComponent, JournalReviewComponent, RecycleBinComponent, AccountingPeriodsComponent, LedgerUnresolvedComponent],
  templateUrl: './ledger.component.html',
  styleUrl: './ledger.component.scss'
})
export class LedgerComponent implements OnInit {
  Roles: LedgerRoles | null = null;
  Loading = true;
  Denied = false;
  AccessMessage = '';

  constructor(private ledger: LedgerService) { }

  ngOnInit() {
    this.ledger.getMyRoles().subscribe({
      next: (me) => {
        this.Loading = false;
        this.Roles = me?.roles || null;
      },
      error: (err) => {
        this.Loading = false;
        this.Denied = err?.status === 403;
        this.AccessMessage = this.Denied
          ? (err?.error?.error || "You don't have access to the Ledger.")
          : `Couldn't check your Ledger access (${err?.status || 'no response'}): ${err?.error?.error || err?.message || 'the API did not answer'}. Make sure the API is running and restarted, then refresh.`;
      }
    });
  }

  get CanView(): boolean { return !!this.Roles?.viewer; }
}
